"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connection = exports.ConnectionManager = void 0;

var schemas_1 = require("@dcl/schemas");

var connectors_1 = require("./connectors");

var storage_1 = require("./storage");

var types_1 = require("./types");

var configuration_1 = require("./configuration");

var ProviderAdapter_1 = require("./ProviderAdapter");

require("./declarations");

var ConnectionManager = /*#__PURE__*/function () {
  function ConnectionManager(storage) {
    _classCallCheck(this, ConnectionManager);

    this.storage = storage;
  }

  _createClass(ConnectionManager, [{
    key: "connect",
    value: function connect(providerType) {
      var chainId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : schemas_1.ChainId.ETHEREUM_MAINNET;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$connector, provider, account;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setConnectionData(providerType, chainId);
                this.connector = this.buildConnector(providerType, chainId);
                _context.next = 4;
                return this.connector.activate();

              case 4:
                _yield$this$connector = _context.sent;
                provider = _yield$this$connector.provider;
                account = _yield$this$connector.account;
                return _context.abrupt("return", {
                  provider: ProviderAdapter_1.ProviderAdapter.adapt(provider),
                  providerType: providerType,
                  account: account || '',
                  chainId: chainId
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "tryPreviousConnection",
    value: function tryPreviousConnection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var connectionData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                connectionData = this.getConnectionData();

                if (connectionData) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('Could not find a valid provider. Make sure to call the `connect` method first');

              case 3:
                return _context2.abrupt("return", this.connect(connectionData.providerType, connectionData.chainId));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getAvailableProviders",
    value: function getAvailableProviders() {
      var available = [types_1.ProviderType.FORTMATIC, types_1.ProviderType.WALLET_CONNECT];

      if (typeof window !== 'undefined' && window.ethereum !== undefined) {
        available.unshift(types_1.ProviderType.INJECTED);
      }

      return available;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _configuration_1$getC, storageKey;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.connector) {
                  _context3.next = 8;
                  break;
                }

                this.connector.deactivate();

                if (!this.isClosableConnector()) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.connector.close();

              case 5:
                _configuration_1$getC = configuration_1.getConfiguration(), storageKey = _configuration_1$getC.storageKey;
                this.storage.remove(storageKey);
                this.connector = undefined;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.connector) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('No valid connector found. Please .connect() first');

              case 2:
                return _context4.abrupt("return", this.connector.getProvider());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "createProvider",
    value: function createProvider(providerType) {
      var chainId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : schemas_1.ChainId.ETHEREUM_MAINNET;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var connector, provider;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                connector = this.buildConnector(providerType, chainId);
                _context5.next = 3;
                return connector.getProvider();

              case 3:
                provider = _context5.sent;
                return _context5.abrupt("return", ProviderAdapter_1.ProviderAdapter.adapt(provider));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "buildConnector",
    value: function buildConnector(providerType, chainId) {
      switch (providerType) {
        case types_1.ProviderType.INJECTED:
          return new connectors_1.InjectedConnector(chainId);

        case types_1.ProviderType.FORTMATIC:
          return new connectors_1.FortmaticConnector(chainId);

        case types_1.ProviderType.WALLET_CONNECT:
          return new connectors_1.WalletConnectConnector();

        case types_1.ProviderType.NETWORK:
          return new connectors_1.NetworkConnector(chainId);

        default:
          throw new Error("Invalid provider ".concat(providerType));
      }
    }
  }, {
    key: "getConnectionData",
    value: function getConnectionData() {
      var _configuration_1$getC2 = configuration_1.getConfiguration(),
          storageKey = _configuration_1$getC2.storageKey;

      var connectionData = this.storage.get(storageKey);
      return connectionData ? JSON.parse(connectionData) : undefined;
    }
  }, {
    key: "setConnectionData",
    value: function setConnectionData(providerType, chainId) {
      var _configuration_1$getC3 = configuration_1.getConfiguration(),
          storageKey = _configuration_1$getC3.storageKey;

      var connectionData = JSON.stringify({
        providerType: providerType,
        chainId: chainId
      });
      this.storage.set(storageKey, connectionData);
    }
  }, {
    key: "isClosableConnector",
    value: function isClosableConnector() {
      return this.connector && typeof this.connector['close'] !== 'undefined';
    }
  }]);

  return ConnectionManager;
}();

exports.ConnectionManager = ConnectionManager;
exports.connection = new ConnectionManager(new storage_1.LocalStorage());